var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('BannerSmall',[_c('h2',{staticClass:"pt-5 pb-5"},[_vm._v("Cash Payment")])]),_c('div',{staticClass:"pt-5 container"},[_c('h5',{domProps:{"innerHTML":_vm._s(_vm.instructions)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }